export const setItemWithExpiry = (key, value) => {
    const now = new Date();
  
    // midnight of today
    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
  
    const item = {
      value: value,
      expiry: endOfDay.getTime(), // store as timestamp
    };
    sessionStorage.setItem(key, JSON.stringify(item));
  };
  
  export const getItemWithExpiry = (key) => {
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) return null;
  
    try {
      const item = JSON.parse(itemStr);
      const now = new Date().getTime();
  
      if (now > item.expiry) {
        sessionStorage.removeItem(key);
        return null;
      }
      return item.value;
    } catch (e) {
      return null;
    }
  };